'use strict';

if (!window.i18n) {
    window.i18n = {};
}

if (!window.i18n.languages) {
    window.i18n.languages = {};
}

window.i18n.languages['id_ID'] = {
	vistor_upsucess:"pembaruan berhasil",
	vistor_accountUp:"Peningkatan akun",
	vistor_upgradeNow:"segera tingkatkan",
	vistor_dear:"Pengunjung yang terhormat:",
	vistor_suggest:"Halo, untuk memberi Anda pengalaman pengguna yang lebih baik, saya sarankan Anda:",
	vistor_click:"Klik \"Peningkatan Akun\" di bawah untuk meningkatkan ke akun resmi",
	vistor_sorry:"Maaf, akun tamu tidak dapat mengubah kata sandi. Demi keamanan akun Anda, harap tingkatkan ke akun resmi",

	change_useridpwd:"konfirmasi akun",
	bizhong_xuanze: "Pilihan mata uang:",

	optional:"Pilihan",
	needBet: "Masih perlu bertaruh:",
	needDeposit:"Masih perlu deposit:",

	agentCode : "Kode invitasi",
	tips_fail:"Klaim gagal",

	a_stauts:"Status aktif",
	activityDetails_hdjxz: "Aktivitas sedang berlangsung",
	activityDetails_hdwks: "Aktivitas tidak dimulai",
	activityDetails_hdyjs: "Aktivitas sudah selesai",
	a_time: `Waktu aktivitas`,
	a_status: `Status aktif`,
	a_rule: `Aturan penghargaan`,
	a_content: `Rincian Aktivitas`,

	gameCoin:"Mata uang game",

	register_chooseCurrency: "Pilih mata uang deposit",
	register_tips0:"*Perubahan mata uang tidak diperbolehkan setelah pendaftaran",
	register_curInstruction:"Deskripsi mata uang:",
	register_tips1:"1. Saat memasuki game yang tidak mendukung mata uang pengguna saat ini,Jumlah yang dikonversi dengan nilai tukar akan dimasukkan ke dalam permainan;",
	register_tips2:"2. Metode deposit / penarikan pengguna adalah dengan menampilkan dukungan mata uang pengguna saat ini;",

	sendSuccess:"Berhasil dikirim!",
	login_areaCode: 'Kode negara',
	login_selectAreaCode: 'Pilih negara atau wilayah',
	new_maxVipLV: 'Selamat! ! Anda saat ini berada di level tertinggi',
	currency_symbol : "Rp",
	language : "BahasaIndonesia",

	new_r_rate: 'Jumlah yang dibawa ke dalam permainan adalah jumlah setelah konversi nilai tukar',
	new_r_rate1: 'kurs：',
	new_r_money: 'uang dalam game：',
	new_r_tips6: '*Harap dicatat bahwa transfer ke permainan tiga pihak hanya dapat menghasilkan bilangan bulat',
	new_r_tips7: 'Pengingat nilai tukar',
	new_r_tips8: 'aku tahu',
	new_r_tips9: 'Anda sedang masuk',
	new_r_game: "permainan",

		"ActivityNew": {
		"btn_lingqu": "dapatkan sekarang",
		"btn_back": "kembali",
		"toggle_zonghe": "Aktivitas yang komprehensif"
	},
	"SignIn": {
		"btnLingqu": "menerima"
	},
	"label_text": {
		"loading_msg": "Unduh paket sumber daya pembaruan untuk Anda",
		"not_logged": "Belum masuk",
		"password": "Kata sandi：",
		"verify": "Kode verifikasi：",
		"verify_msg": "silakan masukkan kode verifikasi",
		"inPlease_enter_the": "silakan masukkan",
		"phone": "HP",
		"No": "No.",
		"determine": "menentukan",
		"receive": "menerima",
		"Image_preview": "Pratinjau Avatar",
		"Install": "Pasang sekarang",
		"obtain": "Selamat Anda mendapatkan",
		"check_update": "Memeriksa pembaruan...",
		"real_name": "nama sebenarnya",
		"tips": "Tolak permainan yang buruk, tolak permainan bajakan. Perhatikan perlindungan diri dan waspadalah terhadap tipu daya. Mainkan game dengan cukup menguntungkan otak, kecanduan game terasa sakit. Atur waktu secara wajar dan nikmati hidup sehat。",
		"title": "Dapatkan imbalan",
		"tishi": "cepat",
		"no_data": "Tidak ada data",
		"queding": "menentukan",
		"quxiao": "membatalkan",
		"download_new_version": "Unduh aplikasi versi terbaru untuk menggunakan fitur ini",
		"online_kefu": "layanan online",
		"save_account": "Simpan informasi akun"
	},
	"data_req_text": {
		"login_failure": "Login telah kedaluwarsa, silakan masuk lagi"
	},
	"login_text": {
		"account_pro": "Akun tidak boleh kosong, silakan isi!",
		"psw_pro": "Kata sandi tidak boleh kosong, silakan isi!",
		"vfy_pro": "Kode verifikasi tidak boleh kosong, silakan isi!",
		"quick_login_fail": "Login tamu",
		"account": "nomor akun：",
		"account_msg": "Silakan masukkan nomor akun / telepon Anda",
		"paw_msg": "Silakan masukkan kata sandi",
		"Remember_acc": "ingat akun",
		"forget_paw": "lupa kata sandi？",
		"no_acc": "Tidak ada akun,",
		"go_reg": "Masuk untuk mendaftar>",
		"confirm_login": "Konfirmasi login",
		"quick_login": "Login Cepat",
		"confirm_register": "Konfirmasikan pendaftaran",
		"register_cg": "registrasi berhasil",
		"account_data": "Informasi Akun",
        "sfyz": "Otentikasi",
        "sfyz_tip": "Pelanggan terhormat!Untuk melindungi keamanan rekening Anda, daftar masuk ini membutuhkan verifikasi berikut untuk mencegah program jahat dari daftar masuk secara otomatis.",
        "bind_bank": "Silakan masukkan kartu bank terikat",
        "bind_alipay": "Silakan masukkan Alipay terikat",
        "bank_card": "Kartu bank:",
        "alipay": "Alipay:",
        "code": "Kode Verifikasi:",
        "enter_bank_card": "Silakan masukkan nomor kartu bank",
        "enter_alipay": "Silakan masukkan nomor rekening Alipay",
        "enter_code": "Silakan masukkan kode verifikasi",
	},
	"register_text": {
		"perfect_suc": "Berhasil melengkapi data!",
		"perfect_err": "Gagal melengkapi data!",
		"inp_data": "Silakan masukkan data terlebih dahulu!",
		"inp_email": "silakan masukkan email",
		"inp_phone": "Silakan masukkan nomor telepon",
		"inp_wx": "Silakan masukkan ID WeChat",
		"inp_qq": "Silakan masukkan nomor QQ",
		"email": "email：",
		"wx_No": "Wechat：",
		"qq_No": "Nomor QQ：",
		"phone": "nomor telepon：",
		"user_name": "nama pengguna：",
		"user_msg": "Masukkan 6-12 digit huruf atau angka akun",
		"user_pro": "kata sandi 6-12 huruf atau angka atau simbol",
		"paw_pro": "Kata sandi adalah kombinasi 6-12 digit dan huruf",
		"confirm_paw_pro": "Kata sandi konfirmasi tidak boleh kosong, silakan isi!",
		"paw_consistent": "Kata sandi dan kata sandi yang dikonfirmasi tidak konsisten, silakan isi kembali!",
		"paw_msg": "Silakan masukkan kata sandi 6-12 huruf dan angka",
		"confirm_msg": "Harap konfirmasi kembali kata sandi",
		"phone_msg": "Silakan masukkan kode verifikasi telepon",
		"con_paw": "konfirmasi sandi：",
		"exi_acc": "Sudah memiliki akun，",
		"go_log": "Pergi untuk masuk>",
		"send_verify": "Kirim",
		"retry_verify": "Kirim ulang",
		"phone_confirm": "Masukkan nomor telepon yang benar!",
		"register_suc": "registrasi berhasil!",
		"user_not_mag": "Nama pengguna tidak boleh kosong, silakan isi!",
		"No_null": "Nomor tidak boleh kosong, silakan isi!",
		"correct_phone": "Masukkan nomor telepon yang benar!",
		"phone_vfy": "Kode verifikasi telepon tidak boleh kosong, silakan isi!",
		"loss_account": "Untuk mencegah kehilangan akun, harap simpan akun tersebut",
		"account_change": "Akun hanya dapat diubah satu kali, klik ubah",
		"please_tick": "Silakan klik tombol centang untuk mengonfirmasi kata sandi akun!",
		"save_suc": "Berhasil disimpan!",
		"save_err": "Gagal disimpan!Harap ambil tangkapan layar secara manual！",

		"currency": "Uang:",
		"language": "Bahasa:",
	},
	"datum_text": {
		"datum_title": "Kirimkan informasi",
		"bank_card": "Nomor kartu bank：",
		"inPlease_enter_the": "silakan masukkan...",
		"input_datum": "Silakan masukkan data terlebih dahulu",
		"update_img": "unggah gambar",
		"select_update_img": "Silakan pilih gambar yang diunggah",
		"limit_type": "Hanya bisa mengunggah JPG、JPEG、PNG",
		"msg_update_data": "Harap unggah data terlebih dahulu",
		"mag_update_pic": "Unggah gambar dalam format yang benar terlebih dahulu",
		"apply_succ": "Permohonan berhasil dikirim, harap tunggu ulasannya"
	},
	"task_text": {
		"activity": "aktivitas",
		"task": "tugas",
		"announcement": "pengumuman",
		"sign": "Masuk",
		"task_name": "nama tugas：",
		"task_detail": "Detail tugas",
		"task_time": "waktu yang efektif untuk tugas：",
		"task_content": "Konten tugas："
	},
	"customer_text": {

		"jump_whatsapp": "Akun whatsapp berhasil disalin, meminta pengalihan ke whatsapp",
		"jump_telegram": "Akun telegram berhasil disalin, meminta pengalihan ke telegram",
		"jump_Messenger": "Akun Messenger berhasil disalin, meminta pengalihan ke Messenger",
		"jump_Viber": "Akun Viber berhasil disalin, meminta pengalihan ke Viber",
		"no_whatsapp": "whatsapp tidak diinstal pada perangkat Anda",
		"no_telegram": "telegram tidak diinstal pada perangkat Anda",
		"no_Messenger": "Messenger tidak diinstal pada perangkat Anda",
		"no_Viber": "Viber tidak diinstal pada perangkat Anda",

		"contact_customer": "Hubungi Layanan Pelanggan",
		"not_ind_qq": "Perangkat Anda tidak terpasang QQ",
		"jump_wx": "Akun WeChat berhasil disalin, meminta pengalihan ke WeChat",
		"not_ind_wx": "WeChat tidak diinstal pada perangkat Anda",
		"jump_mt": "Akun layanan pelanggan MT berhasil disalin, meminta pengalihan ke layanan pelanggan MT",
		"Online": "layanan online",
		"QQ": "Layanan pelanggan QQ",
		"WECHAT": "Layanan Pelanggan WeChat",
		"MT": "Layanan pelanggan MT",
		"CJ": "masalah umum",
		"contact_online": "Hubungi Layanan Pelanggan",
		"copy_wx": "Salin ID WeChat",
		"copy_mt": "Salin nomor MT"
	},
	"msg_text": {
		"save_date": "Pesan disimpan hingga satu bulan",
		"message": "berita",
		"email": "email",
		"receive": "Diterima",
		"overdue": "kedaluwarsa",
		"not_delete": "Tidak bisa dihapus, tolong terima hadiahnya terlebih dahulu",
		"not_be_deleted": "Surat yang tidak diterima tidak akan dihapus"
	},
	"basic_text": {
		"basic_title": "Informasi dasar",
		"account": "nomor akun：",
		"nickname": "Nama panggilan：",
		"name": "Nama：",
		"com_title": "Informasi komunikasi",
		"qq": "Q Q：",
		"wx": "Wechat：",
		"phone": "HP：",
		"email": "email："
	},
	"baes_text": {
		"unit": "yuan",
		"view": "Melihat 》",
		"yes": "Iya",
		"no": "tidak",
		"update": "Memperbarui",
		"cancel": "membatalkan",
		"mail_system": "Surat email sistem",
		"connected": "Menghubungkan, harap tunggu dengan sabar...",
		"coin": "emas"
	},
	"pre_details_text": {
		"rkz": "Menyetor...",
		"copy": "menyalin",
		"order": "jumlah order",
		"date": "waktu isi ulang",
		"czType": "Metode isi ulang",
		"transfer": "Transfer",
		"succ": "berhasil",
		"error": "gagal",
		"audit": "sedang ditinjau",
		"czSucc": "Pengisian ulang gagal",
		"copy_succ": "Salin berhasil",
		"order_num": "no. order",
		"detail": "Detail isi ulang",
		"lxkf": "Hubungi Layanan Pelanggan"
	},
	"USDT_text": {
		"second_step": "Tahap kedua：Informasi rantai USDT",
		"url_name": "Nama rantai",
		"alipay": "Bayar dengan Alipay",
		"url": "Alamat rantai..."
	},
	"set_text": {
		"set_music": "Pengaturan musik",
		"switch_music": "Pergantian musik",
		"change_d_paw": "Ubah kata sandi masuk",
		"change_t_paw": "Ubah kata sandi penarikan",
		"version": "versi sekarang",
		"huidu": "Skala abu-abu",
		"swi_test": "Apakah akan beralih ke beta？",
		"swi_hui": "Apakah akan beralih ke skala abu-abu？",
		"old_paw_null": "Kata sandi lama tidak boleh kosong, silakan isi!",
		"new_paw_null": "Kata sandi baru tidak boleh kosong, silakan isi!",
		"old_paw_limit_length": "Kata sandi lama adalah 6-12 digit",
		"new_paw_limit_length": "Kata sandi baru adalah kombinasi 6-12 digit dan huruf",
		"new_paw_limit": "Kata sandi yang lama harus terdiri dari 6 digit, harap isi kembali",
		"con_paw_null": "Kata sandi konfirmasi tidak boleh kosong, silakan isi!",
		"con_paw_consistent": "Kata sandi dan kata sandi yang dikonfirmasi tidak konsisten, silakan isi kembali!",
		"new_old_paw_consistent": "Kata sandi baru tidak boleh sama dengan kata sandi lama, silakan isi kembali!",
		"change_succ": "Selamat, Anda telah berhasil mengubah kata sandi Anda, silakan masuk lagi!",
		"tx_paw_null": "Kata sandi penarikan tidak boleh kosong, harap isi",
		"con_tx_paw": "Konfirmasi kata sandi penarikan tidak boleh kosong, harap isi",
		"tx_paw_consistent": "Kata sandi penarikan tidak konsisten dengan kata sandi konfirmasi, mohon konfirmasi",
		"tx_paw_limit": "Kata sandi penarikan harus 6 digit, harap isi kembali",
		"paw_change_succ": "Selamat, Anda telah berhasil mengubah kata sandi Anda",
		"latest_version": "Ini adalah versi terbaru dari App",
		"switch_server": "Ganti server",
		"switch_language": "Ganti bahasa",
		"change_language_tips": "Bahasa beberapa halaman akan mulai berlaku setelah aplikasi dimulai ulang",
		"restart": "Mulai ulang"
	},
	"share_text": {
		"copy_wa": "Salin teks",
		"save_img": "Simpan gambar",
		"share_py": "Bagikan momen teman",
		"submit_audit": "Kirim ulasan",
		"copy_succ": "Salin berhasil",
		"save_img_succ": "Gambar berhasil disimpan",
		"save_err": "Gagal simpan gambar. Silakan buka halaman pengaturan telepon untuk membuka izin aplikasi ini untuk menyimpan gambar",
		"share_go": "bagikan ke：",
		"share_err_qq": "Gagal berbagi, silakan instal atau periksa QQ dan coba lagi",
		"share_err_wx": "Gagal berbagi, silakan instal atau periksa WeChat dan coba lagi",
		"share_err_wl": "Gagal diikat, silakan periksa jaringan dan coba lagi",
		"shareIntroduce_title": "Bagikan tutorial",
		"inviteFriends": "mengundang teman-teman"
	},
	"hot_text": {
		"dzyx": "Mengumpulkan permainan video populer di seluruh dunia, antusiasme tidak berkurang, tingkat kemenangan lebih tinggi, dan sepuluh juta hadiah menunggu Anda untuk menang!",
		"qbyx": "Mengumpulkan permainan kartu catur populer di seluruh dunia, antusiasme tidak berkurang, tingkat kemenangan lebih tinggi, dan sepuluh juta hadiah menunggu Anda untuk menang!",
		"byyx": "Mengumpulkan permainan penangkapan ikan populer di seluruh dunia, antusiasme tidak berkurang, tingkat kemenangan lebih tinggi, dan sepuluh juta hadiah menunggu Anda untuk menang!",
		"rmqp": "Catur populer",
		"rmdz": "Elektronik Populer",
		"rmby": "Memancing populer",
		"ljyx": "Main sekarang"
	},
	"agent_text": {
		"my_id": "ID saya：",
		"under": "Komisi langsung kemarin：",
		"offline": "Komisi offline kemarin：",
		"under_player": "Pemain langsung：",
		"day_new": "Ditambahkan kemarin：",
		"offline_player": "Pemain offline：",
		"bind_wx": "Ikat ke WeChat",
		"share_rewards": "Bagikan hadiah：",
		"commission_ins": "Tanggal penyelesaian komisi adalah penyelesaian harian, berbagi dengan teman atau momen teman bisa mendapatkan hadiah berbagi!"
	},
	"vip_text": {
		"my_level": "Tingkatanku：",
		"current_code": "Jumlah pengkodean saat ini：",
		"was_filed": "Hadiah peningkatan",
		"was_filed_info": "Peningkatan dapat menerima hadiah",
		"weeks_amounts": "Hadiah mingguan",
		"weeks_amounts_info": "Distribusi gratis setiap hari Senin",
		"month_amounts": "Hadiah bulanan",
		"month_amounts_info": "Didistribusikan tepat waktu pada tanggal 1 setiap bulan",
		"wash_code": "Cuci kode",
		"wash_code_info": "Rasio cuci kode tertinggi",
		"but_text": "Pergi sekarang",
		"get_error": "Gagal mendapatkan koin emas, segarkan kembali koin emas itu!",
		"amount_code": "Jumlah kode",
		"title": "VIP saya",
		"backToMe": "Kembali ke milikku",
		"me": "saya"
	},
	"xima_text": {
		"game_type": "tipe permainan",
		"dm_total": "Jumlah taruhan efektif",
		"proportion": "Rasio pengkodean tertinggi",
		"xm_amount": "Jumlah cuci kode",
		"can_led_take": " Tersedia",
		"xm_total": "Jumlah total cuci kode"
	},
	"PlayerCenter": {
		"note": "Catatan",
		"betting_record": "catatan taruhan",
		"trading_hours": "jam transaksi",
		"trading_type": "tipe transaksi",
		"change_amount": "Ubah jumlahnya",
		"balance": "saldo",
		"today": "hari ini",
		"yesterday": "kemarin",
		"a_month": "Sebulan",
		"all": "Semua",
		"status": "status perdagangan",
		"chess": "Catur",
		"send_time": "Waktu dapat taruhan",
		"note_num": "Nomor taruhan game",
		"betting_amount": "Jumlah taruhan",
		"has_been": "Diberi hadiah",
		"gaming": "platform game",
		"jbxx": "Informasi dasar",
		"zhmx": "Detail akun",
		"zdlb": "Daftar taruhan",
		"my_vip": "VIP saya",
		"save": "menyimpan",
		"edit": "edit",
		"currencyType":"Ubah mata uang",

	},
	"RechargeLayer": {
		"note": "Catatan",
		"often_play": "Jumlah cepat yang sering dimainkan pemain",
		"between": "Silakan masukkan jumlah antara 1 ~100",
		"gift100": "100% gratis",
		"payment_account": "akun penerimaan uang",
		"payee": "Nama",
		"where": "bank akun",
		"depositors": "Silakan isi nama asli deposan",
		"note_info": "Keterangan informasi",
		"step": "Langkah pertama: Pindai kode QR pembayaran dan isi ulang",
		"step2": "Langkah kedua: Isi informasi isi ulang Anda dan kirim isi ulang",
		"session": "Pembicaraan terakhir",
		"official": "Sertifikasi resmi",
		"gift2": "2% gratis",
		"channel": "*Silakan pilih saluran isi ulang\n*Sebelum memilih saluran, harap periksa nilai tukar dengan cermat",
		"qr_code": "Simpan  nSimpan  nDua  nDimensi  nKode",
		"digital_currency": "Saluran isi ulang mata uang digital 1",
		"step_1": "Langkah pertama: Pilih jumlah USDT",
		"formula": "Rumus perhitungan untuk pengisian ulang akhir ke jumlah akun: 70.86 = 10.1234USDT * nilai tukar saat ini 7 yuan",
		"step3": "Langkah ketiga: Berikan informasi penarikan",
		"actual_account": "Jumlah aktual dari USDT yang diterima",
		"poundage": "Biaya penanganan 0-50USDT",
		"instr": "*Silakan isi dengan ketat seperti yang ditunjukkan pada gambar kiri!  n * Jika salah mengisi, tidak dapat tiba tepat waktu!",
		"not_account": "Isi ulang belum tiba?",
		"rate": "kurs：1USDT=99yuan",
		"prompt_info": "Informasi petunjuk",
		"currency_symbol": "Rp",
		"currency_word": "IDR",
		"czjl": "Isi ulang catatan",
		"czjc": "Tutorial isi ulang",
		"ljcz": "Isi ulang sekarang",
		"czje": "Isi ulang jumlah",
		"zfpz": "Nama Deposit",
		"save_code": "Simpan kode QR",
		"xuanchuan": "Agen resmi mengisi ulang\n        Jaminan reputasi mutlak",
		"usdt_address": "Alamat deposit USDT:",
		"syb": "Sebelumnya",
		"complete": "bawa",
		"usdt_num": "Setor sejumlah USDT:",
		"go_recharge": "Pergi ke top up",
		"back": "kembali",
		"creat_order": "Buat Pesanan",
		"real_usdt": "Jumlah sebenarnya dari USDT yang diterima",
		"sxf": "Biaya penanganan",
		"date": "waktu",
		"state": "status",
		"jine": "Jumlah",
		"detail": "Detail",
		"rechargeCourse": "Tutorial isi ulang",
		"rate2coin": "kurs:1 koin emas = ",
		"get_coins": "Koin emas diterima:",
		"get_money": "Jumlah yang diterima:",
        "go_pay": "Salinan berhasil. Ingin segera membayar?",
        "pay_now": "Bayar segera",
        "pay_not_support": "Tidak dapat melakukan pembayaran untuk sementara!",
	},
	"SettingLayer": {
		"bind_equi": "Mengikat perangkat",
		"basic_info": "informasi dasar",
		"account": "nomor akun：",
		"level": "Tingkat：",
		"set_sound": "Pengaturan suara",
		"music": "musik",
		"sound": "Efek suara",
		"switch_music": "Pergantian musik",
		"song2": "harus mencintai ketika mati",
		"song1": "lagu1",
		"inp_landing_paw": "Silakan masukkan kata sandi login",
		"inp_old_paw": "Silakan masukkan kata sandi lama",
		"old_paw": "kata sandi lama：",
		"inp_new_paw": "Silakan masukkan kata sandi baru",
		"new_paw": "kata sandi baru：",
		"con_new_paw": "Konfirmasikan kata sandi baru",
		"con_paw": "konfirmasi kata sandi：",
		"check_update": "Periksa pembaruan",
		"determine": "Konfirmasikan",
		"bind_shuom1": "*Setelah mengikat perangkat, dapat menggunakan login cepat untuk login langsung ke perangkat yang terikat.",
		"bind_shuom2": "*Daftarkan akun dengan login cepat, secara otomatis mengikat perangkat saat ini.",
		"bind_shuom3": "*Setelah mengikat perangkat, dapat memverifikasi identitas dan melepaskan ikatan.",
		"bind_shuom4": "*Untuk memverifikasi identitas, harus memasukkan kata sandi login.",
		"bind_shuom5": "*Silakan gunakan dengan hati-hati!",
		"bind_shuom6": "Perangkat saat ini telah diikat",
		"bind_shuom7": "Perangkat lain sudah terikat",
		"landing_paw": "kata sandi masuk：",
		"test": "lingkungan pengujian",
		"huidu": "Lingkungan abu-abu",
		"standbyTest": "Lingkungan pengujian alternatif",
		"mute_all": "Bisukan semua",
		"change_account": "Ganti akun",
		"confirm_change": "Konfirmasikan perubahan",
		"confirm_bind": "Pengikatan perangkat",
		"unbind_device": "Lepaskan perangkat",
		"unbind": "Memperlonggar"
	},
	"Task": {
		"share_task": "Bagikan tugas",
		"MG_electronic": "elektronik MG",
		"cash": "tunai",
		"complete": "pergi selesai",
		"application": "Menerapkan",
		"refused": "ditolak",
		"disclose_data": "Kirimkan informasi",
		"submit": "Kirimkan",
		"Audit_failure": "Kegagalan audit",
		"friends_account": "Kirim tangkapan layar",
		"apply_reward": "Terapkan untuk hadiah",
		"pic_limit": "Hanya JPG, JPEG, PNG yang dapat diunggah, tidak lebih dari 1 M",
		"update_pic": "unggah gambar",
		"task_details": "Detail tugas",
		"Task_details": "Detail tugas：",
		"task_name": "nama tugas：",
		"task_state": "Deskripsi tugas：",
		"share": "bagikan ini",
		"task_progress": "kemajuan tugas：",
		"know": "aku tahu",
		"q_update_pic": "Unggah gambar dulu",
		"activit_Shut": "Aktivitas tugas ditutup",
		"Qbind_wx": "Tolong ikat WeChat dulu",
		"Application_success": "Aplikasi berhasil, harap tunggu ulasannya",
		"Succ_application_Award": "Aplikasi yang berhasil untuk hadiah",
		"task_ShutDown": "Tugas berbagi sudah ditutup",
		"btn_choose": "Pilih",
		"editTips": "Pilih gambar yang diunggah"
	},
	"ThirdGamesListLayer": {
		"xsj": "Catur dunia baru",
		"tall_game": "Total 1 permainan",
		"inp_game": "Silakan masukkan nama permainan"
	},
	"TuiGuangLayer": {
		"my_agent": "Agen saya",
		"agent_introduced": "Pengantar agen",
		"players_query": "pertanyaan pemain",
		"results_query": "pertanyaan kinerja",
		"rich_list": "Daftar kekayaan",
		"my_id": "ID saya：",
		"under": "Komisi langsung kemarin：",
		"offline": "Komisi offline kemarin：",
		"under_player": "Pemain langsung：",
		"day_new": "Ditambahkan kemarin：",
		"offline_player": "Pemain offline：",
		"share_rewards": "Bagikan hadiah：",
		"commission_ins": "Tanggal penyelesaian komisi adalah penyelesaian harian, berbagi dengan teman atau momen teman bisa mendapatkan hadiah berbagi!",
		"save_qr_code": "Simpan kode QR",
		"copy": "menyalin",
		"bind_wx": "Ikat ke WeChat",
		"Imm_receive": "Dapatkan sekarang juga",
		"share_detail": "Bagikan detail",
		"get_record": "Catatan penerimaan",
		"zhishu_renshu": "Jumlah langsung：",
		"tall_bets_today": "Total taruhan berlaku hari ini：",
		"inp_id": "Silakan masukkan ID",
		"query": "Menanyakan",
		"reset": "Setel ulang",
		"bets_today": "Taruhan yang valid hari ini",
		"total_bets": "Total taruhan efektif",
		"directly_num": "Jumlah langsung",
		"operation": "Pengoperasian",
		"details": "Detail>>",
		"date": "tanggal",
		"under_new": "Ditambahkan langsung",
		"team_new": "Ditambahkan tim",
		"directly_under": "rabat langsung",
		"total_amount": "Total rabat",
		"reward": "Hadiah",
		"ranking": "Pangkat",
		"player_info": "Informasi pemain",
		"rebate_month": "Komisi hadiah rabat bulan ini",
		"rewards_month": "hadiah berbagi bulan ini",
		"detailed_info": "informasi detail",
		"zhuce_shijian": "Waktu pendaftaran：",
		"jtyxtz": "Taruhan yang valid hari ini：",
		"tdrsxz": "Ukuran tim (baru)：",
		"jrtdyxtz": "Taruhan tim berlaku hari ini：",
		"directly_num_new": "Jumlah langsung (baru)：",
		"zuoriyongjing": "Komisi kemarin：",
		"commission_payable": "Komisi yang dapat ditarik：",
		"lishizongyong": "Total komisi historis：",
		"zyxtz": "Total taruhan efektif：",
		"agent_commission": "Komisi agensi",
		"share_commission": "Komisi berbagi",
		"team_num": "Jumlah tim",
		"not_directly_under": "rabat tidak langsung",
		"account": "nomor akun",
		"between": "hubungan",
		"effective_betting": "Taruhan / jumlah rabat efektif",
		"ratio": "Rasio rabat",
		"total": "total",
		"share": "bagikan",
		"title": "Agen Promosi",
		"agent_recruit": "Perekrutan agen",
		"historyCom": "Total komisi historis",
		"canReceive": "Komisi yang dapat diterima",
		"contact": "Hubungi tutor"
	},
	"WithdrawLayer": {
		"self_help": "Penarikan layanan mandiri",
		"withdrawal_record": "Catatan penarikan",
		"wallet_management": "Manajemen dompet",
		"inp_withdrawal_amount": "Silakan masukkan jumlah penarikan",
		"warm_prompt": "pengingatan hangat",
		"current_need_adjust_amount": "Masih membutuhkan detail transaksi<color=#00ff00>0</c>sebelum penarikan tunai",
		"current_need": "Masih membutuhkan",
		"can_carry": "detail transaksi, sebelum penarikan tunai",
		"adjust_amount": "Seret titik untuk menyesuaikan jumlah penarikan tunai",
		"bank": "ICBC",
		"change_bank_card": "Ganti kartu bank",
		"not_bind_card": "Anda belum mengikat kartu bank saat ini, silakan pergi ikat",
		"not_tixian_paw": "Anda belum menetapkan kata sandi penarikan, harap setel kata sandi penarikan terlebih dahulu",
		"tixian_paw": "Kata sandi penarikan",
		"set6num_paw": "Silakan mengatur kata sandi 6 digit",
		"confirm_password": "konfirmasi sandi",
		"again_confirm_password": "Silakan masukkan kata sandi lagi untuk mengonfirmasi",
		"inp_tixian_paw": "Silakan masukkan kata sandi penarikan",
		"topUp_failure": "Pengisian ulang gagal",
		"bank_paragraph": "Penarikan bank",
		"add_card": "Tambahkan kartu bank",
		"cardholder_name": "Silakan masukkan nama pemegang kartu",
		"cardholder": "pemegang kartu：",
		"card_code": "Rekening kartu bank：",
		"inp_bank_card_code": "Silakan masukkan nomor kartu bank",
		"inp_bank_address": "Silakan masukkan alamat pembukaan bank",
		"bank_address": "Alamat pembukaan rekening:",
		"bank_address_msg": "Pengingatan: Silakan pilih bank pembukaan rekening dengan benar dan ikat nama aslinya. Ini akan langsung ditransfer ke akun ini selama penyelesaian. Untuk keamanan dana Anda, tidak dapat mengubahnya sesuka hati setelah mengikat. Jika perlu mengubahnya, silakan hubungi layanan pelanggan.",
		"choose_bank": "Pilih Bank：",
		"inp_aliPay_name": "Silakan masukkan nama asli Alipay",
		"inp_aliPay_code": "Silakan masukkan akun Alipay",
		"name": "Nama：",
		"aliPay_account": "Akun Alipay：",
		"aliPay_account_msg": "Pengingatan: Silakan pilih Alipay dengan benar, dan itu akan langsung ditransfer ke akun ini selama penyelesaian. Untuk keamanan dana Anda, tidak dapat mengubahnya sesuka setelah mengikat. Jika Anda perlu mengubahnya, silakan hubungi layanan pelanggan.",
		"inp_tixian_dizhi": "Silakan masukkan alamat penarikan",
		"rate": "kurs",
		"daozhangUSDT": "Jumlah USDT diterima",
		"confirm_tixian": "Konfirmasikan penarikan",
		"max": "maksimum",
		"confirm_submit": "Konfirmasi Pengiriman",
		"tixian_time": "Waktu penarikan",
		"jine": "Jumlah",
		"state": "status",
		"order_info": "informasi pemesanan",
		"confirm_bind": "Tentukan pengikatan",
		"confirm_select": "Konfirmasikan pilihan",
		"select_bank_card": "Pilih kartu bank",
		"bizhong_xuanze": "Pilihan mata uang:",
		"tixian_dizhi": "Alamat penarikan:",
		"more_than_0": "Jumlah penarikan harus lebih besar dari 0"
	},
	"XimaLayer": {
		"selfHelp_washing": "Kode cuci sendiri",
		"xima_record": "catatan cuci kode",
		"xima_proportion": "rasio cuci kode",
		"fishing_game": "Game penangkapan ikan",
		"to_complete": "pergi selesai",
		"receive": "menerima",
		"chess": "Catur",
		"fishing": "Penangkapan ikan",
		"electronic": "elektronik",
		"reality": "Orang asli",
		"sports": "olahraga",
		"eSports": "Olahraga Elektronik",
		"lottery": "Lotre",
		"game": "permainan",
		"key_get": "sekali klik untuk menerima",
		"get_time": "Waktu penerimaan",
		"damaliang": "Jumlah taruhan efektif",
		"xima_amount": "Jumlah cuci kode",
		"details": "Detail",
		"viewI": "Melihat>>",
		"xima_details": "Rincian cuci kode",
		"heitao_chess": "catur sekop",
		"chess_game": "permainan catur",
		"sports_events": "Acara olahraga",
		"electronic_game": "Game elektronik",
		"lottery_betting": "Taruhan lotere",
		"real_video": "Video langsung",
		"eSports_game": "Game olahraga elektronik",
		"game_name": "Nama permainan",
		"click_details": "Klik untuk detailnya",
		"tianmei_chess": "Catur Tianmei",
		"detailsI": "Detail>>",
		"xima_range": "Kisaran pencucian kode",
		"vip_level": "Tingkat vip",
		"tournament": "pertandingan olahraga elektronik",
		"lottery_game": "Game lotere",
		"title": "Kode cuci"
	},
	"Signal": {
		"switch": "Ganti jalur",
		"speed": "jalur akselerasi",
		"choose": "Pilih jalur",
		"reconnect": "terhubung kembali",
		"helpful_hints": "Pengingatan ramah: semakin rendah penundaan, semakin baik jaringan",
		"is_msg": "Ini pesan",
		"in_test": "memeriksa",
		"general": "umum",
		"smooth": "lancar",
		"speed1": "tercepat",
		"current_use": "Saat ini digunakan"
	},
	"general": {
		"name": "Nama",
		"activity": "Kegiatan yang komprehensif",
		"xzsm": "penerbit alamat, dapatkan alamat instalasi terbaru kapan saja.",
		"wszl": "melengkapi informasi",
		"qdcj": "Bonus masuk",
		"xtyj": "Surat email sistem",
		"xxzx": "Pusat pesan",
		"bt": "judul",
		"sj": "waktu",
		"nr": "konten",
		"xx": "berita",
		"dlq": "Menunggu keputusan",
		"ylq": "Diterima",
		"ygq": "kadaluarsa",
		"ready_all": "Semua sudah dibaca",
		"del_all": "Hapus semua",
		"get_all": "Klaim semua"
	},
	"EllipticalStage": {
		"musicNmae": "Untuk kemenangan"
	},
	"CheckHot": {
		"update_msg": "Pembaruan versi baru terdeteksi, unduhan selesai untuk Anda, klik untuk menyelesaikan pembaruan!",
		"update": "Memperbarui",
		"lack_resources": "Kurangnya sumber daya seni",
		"kaiyuan_chess": "Catur Kaiyuan",
		"leyou_chess": "Catur Leyou",
		"xinshijie_chess": "Catur dunia baru",
		"ag_electronic": "Elektronik AG",
		"pg_electronic": "Elektronik PG",
		"mg_electronic": "Elektronik MG"
	},
	"HallUI": {
		"copy_succ": "Salin berhasil",
		"moment_open": "Belum buka",
		"no_announcement": "Tidak ada konten pengumuman",
		"tmpled_err": "Kesalahan konfigurasi template, silakan hubungi layanan pelanggan",
		"game_maintain": "Permainan sedang dalam perbaikan",
		"game_loading": "Game sedang memuat",
		"get_err": "Gagal mendapatkan koin emas, segarkan kembali koin emas itu!",
		"login": "Gabung",
		"register": "terdaftar",
		"copy_id": "Salin ID",
		"huodong": "aktivitas",
		"task": "tugas",
		"setting": "Mempersiapkan",
		"remen": "Populer",
		"qipai": "Catur",
		"buyu": "Penangkapan ikan",
		"zhenren": "Orang asli",
		"dianzi": "elektronik",
		"tiyu": "pendidikan Jasmani",
		"caipiao": "Lotre",
		"dianjing": "Bermain game",
		"tuiguangdaili": "Agen Promosi",
		"xima": "Kode cuci",
		"xiaoxi": "berita",
		"kefu": "Pelayanan pelanggan",
		"xiufugongju": "Alat perbaikan",
		"gengduo": "Lebih",
		"qiandao": "Masuk",
		"paihangbang": "Papan peringkat",
		"gonggao": "pengumuman",
		"tixian": "menarik",
		"chongzhi": "Isi ulang",
		"xianshilingqu": "Koleksi waktu terbatas",
		"remenyouxi": "game top",
		"zuijingchangwan": "Terakhir diputar",
		"play_now": "Taruhan"
	},
	"BasicsJS": {
		"tall": "Total",
		"minGame": "Game kecil",
		"play_game": "Tidak ada permainan yang baru-baru ini dimainkan",
		"editor_succ": "Edit berhasil",
		"yi_bind": "Terikat",
		"wu_bind": "Tidak terikat",
		"inp_amount": "Silakan masukkan jumlah isi ulang",
		"inp_correct_amount": "Silakan masukkan jumlah isi ulang yang benar",
		"no_login_yinshang": "belum masuk ke usaha bank",
		"gift": "gratis",
		"voucher_cannot_empty": "Voucher pembayaran tidak boleh kosong",
		"pic_loading": "Gambar sedang dimuat",
		"amount_between": "Jumlah antara",
		"card": "kartu",
		"note_info": "Isi informasi catatan untuk mendapatkan uang lebih cepat",
		"credit_cord": "Nomor Akun",
		"rate": "kurs",
		"not_channel": "Saluran isi ulang tidak ada, silakan hubungi layanan pelanggan",
		"select_amount": "Silakan pilih jumlah isi ulang",
		"confirm_cancellation_order": "apakah yakin membatalkan pesanan",
		"been_submit": "Pesanan telah dikirimkan, harap tunggu dengan sabar",
		"Eventually_topUp_amount": "Jumlah isi ulang akhir adalah",
		"current_rate": "Nilai tukar saat ini",
		"Outstanding_orders": "Anda memiliki pesanan yang belum selesai, apakah akan melanjutkan",
		"Continue": "lanjutkan",
		"Cancel_order": "Batalkan pesanan",
		"bind_succ": "Mengikat dengan sukses",
		"inp_paw": "Silakan masukkan kata sandi terlebih dahulu",
		"remove_bind_succ": "Lepaskan ikatan dengan sukses",
		"first": "Pertama",
		"day": "hari",
		"Sports_eSports": "Olahraga elektronik",
		"directly": "langsung",
		"not_directly": "Tidak langsung",
		"amount_not_null": "Jumlah penarikan tidak boleh kosong, silakan isi",
		"WithdrawalAmount": "Jumlah penarikan",
		"Qbind": "Tolong ikat dulu",
		"moment_not_bind": "Anda saat ini tidak terikat",
		"QgoBind": "Silakan pergi untuk mengikat",
		"replace": "menggantikan",
		"between": "antara",
		"request_submit": "Permintaan penarikan telah diajukan",
		"ContinueToCarry": "Terus menarik",
		"GiveUpWithdrawal": "Keluar dari penarikan",
		"Qxuanding": "pengingatan: Silakan pilih dengan benar",
		"jiesuanshihou": "Ini akan ditransfer langsung ke sini",
		"zhuanghaowanquan": "Nomor akun, untuk keamanan dana Anda, tidak dapat diubah sesuka hati setelah mengikat. Jika Anda perlu mengubahnya, silakan hubungi layanan pelanggan.",
		"phoneNo": "nomor telepon",
		"add": "Tambahkan",
		"updateTimeout": "Periksa batas waktu pembaruan, harap konfirmasikan apakah jaringan Anda normal",
		"retry": "Mencoba kembali",
		"err_retry": "Kesalahan saat mengunduh file, silakan coba lagi",
		"err_check_network": "Gagal mengunduh file, harap konfirmasikan apakah jaringan Anda normal",
		"no_get_data": "Tidak ada pembaruan sumber daya yang diperoleh, silakan coba lagi nanti",
		"network_retry": "Jaringan terputus, periksa apakah koneksi jaringan Anda normal",
		"Quit_game": "keluar dari game",
		"ReturnHall": "Kembali ke lobi",
		"daozhangUSDT": "Jumlah USDT diterima"
	}
};
